import { useEffect, useState } from "react";
import styles from "./antheRsCard.module.css";

import Highcharts from "highcharts";
const AnthePerformanceCard = ({ Response, renderTo, exam_type }) => {
  const selectedSeries =
    exam_type === "iACST"
      ? [
          Response.score_metrics[0], // Won't be shown
          Response.score_metrics[1], // Your Scores
          Response.score_metrics[4], // Average Scores
          Response.score_metrics[2], // Maximum Marks
        ]
        : exam_type === "IAT"
        ? [
            Response.score_metrics[0], // Won't be shown
            Response.score_metrics[1], // Your Scores
            Response.score_metrics[2], // Maximum Marks
            Response.score_metrics[4], // Average Scores
          ]
      : [
          Response.score_metrics[0], // Won't be shown
          Response.score_metrics[1], // Your Scores
          Response.score_metrics[2], // Maximum Marks
          Response.score_metrics[3], // Highest Marks
          Response.score_metrics[4], // Average Scores
        ];
       
  useEffect(() => {
    new Highcharts.Chart({
      chart: {
        // styledMode: true,
        renderTo: renderTo,
        type: "column",
        width: "1350",
        height: "550",
        shadow: false,
        borderWidth: 0.3,
        borderRadius: 6,
        borderColor: "#C5C6C6",
        borderStyle: "dotted",
        scrollablePlotArea: {
          minWidth: "600",
          scrollPositionX: 0,
        },
        style: {
          fontFamily: "Outfit-Medium !important",
        },
        spacing: 15,
      },
      title: {
        text: `YOUR SUBJECT WISE PERFORMANCE WITH AVERAGE & ${exam_type === "iACST" ? 'HIGHEST SCORER' : 'HIGHEST SCORER'}`,
        style: {
          fontFamily: "Outfit-Medium !important",
          fontWeight: "bold",
          color: exam_type === 'iACST' ? '#009CDE' : '#2B7DCA',
          fontSize: "28px",
          marginBottom: "40px",
        },
        align: "center",
      },
      // legend: {
      //   symbolHeight: exam_type === "iACST" ? 12 : undefined,
      //   symbolWidth: exam_type === "iACST" ? 12 : undefined,
      //   symbolRadius: exam_type === "iACST" ? 0 : undefined,
      // },
      legend: {
        symbolHeight: exam_type === "iACST" || exam_type === "IAT" ? 12 : undefined,
        symbolWidth: exam_type === "iACST" || exam_type === "IAT" ? 12 : undefined,
        symbolRadius: exam_type === "iACST" || exam_type === "IAT" ? 0 : undefined,
      },
      xAxis: {
        lineColor: "#5b5b5b",
        lineWidth: 1,
        categories: Response.subjects,
        labels: {
          style: {
            color: "#2B7DCA",
            fontFamily: "Outfit-Medium !important",
            fontSize: "18px",
            fontWeight: "bold",
          },
        },
      },

      yAxis: {
        tickAmount: 9,
        lineColor: "#5b5b5b",
        lineWidth: 0,
        tickInterval: 5,
        // gridLineColor: "#b2b3b3",
        // gridLineWidth: "10px",
        gridLineDashStyle: "dash",
        title: {
          text: "",
        },
        labels: {
          style: {
            color: "#2B7DCA",
            fontFamily: "Outfit-Medium !important",
            fontSize: "16px",
            fontWeight: "bold",
          },
        },
      },
      tooltip: {
        style: {
          display: "none",
        },
      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            style: {
              color: "black",
              fontFamily: "Outfit-Medium !important",
              fontSize: "16px",
              fontWeight: "bold",
            },
            align: "top",
            color: "black",
            x: 0,
          },
          pointPadding: 0,
        },
      },
      credits: {
        enabled: false,
      },
      series: selectedSeries.map((ele, ind) => {

        // console.log("index check", ind, ind < Response.subjects.length);
        return {
          name: ind > 0 ? ele.metric : "",
          legendSymbol: exam_type === "IAT" ? "rectangle" : "circle",
          style: {
            fontFamily: "Outfit-Medium !important",
          },

          data:
            ind > 0 &&
            ele.values
              .slice(0, Response.subjects.length)
              .map(
                (i, index) =>
                  index < Response.subjects.length &&
                  Number(Number(i).toFixed(1))
              ),
          color: `${
            exam_type === "iACST" 
            ? (ind === 0 ? "white" : ind == 1 ? "#FE9085" : ind == 2 ? "#FCBE23" : "#029FE1") 
            : (ind == 0 ? "white" : ind == 1 ? "#EE857D" : ind == 2 ? "#FCC025" : ind == 3 ? "#029FE1" : "#81CAC6")
          }`,
        };
      }),
    });
  }, []);

  return (
    <>
      <div className={`${styles.card115} mx-auto d-flex`}></div>
    </>
  );
};
export default AnthePerformanceCard;
